import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import weddingImage from "../../assets/hands-indian-bride-groom-intertwined-together-making-authentic-wedding-ritual.jpg";
import preWeddingImage from "../../assets/prewedding.png";
import babyShowerImage from "../../assets/babyshower.jpg";
import birthdayImage from "../../assets/birthday.jpg";
import eventImage from "../../assets/ Event.jpg"; // Remove the space before Event.jpg

const categories = [
  {
    title: "Wedding",
    image: weddingImage,
  },
  {
    title: "Pre Wedding",
    image: preWeddingImage,
  },
  {
    title: "Baby Shower",
    image: babyShowerImage,
  },
  {
    title: "Birthday",
    image: birthdayImage,
  },
  {
    title: "Events",
    image: eventImage,
  },
];

const Categories = () => {
  return (
    <section id="services" className="bg-black py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gradient-to-r from-amber-400 to-transparent"></div>
            <p className="text-xs uppercase tracking-[4px] text-amber-400 font-bold">
              Our Services
            </p>
          </div>

          <h2 className="text-5xl md:text-6xl font-black text-white">
            Featured Categories
          </h2>
        </div>

        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          loop={true}
          speed={1000}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          navigation
          pagination={{ clickable: true }}
          spaceBetween={20}
          breakpoints={{
            320: {
              slidesPerView: 1,
            },
            640: {
              slidesPerView: 1.3,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 2.8,
            },
            1280: {
              slidesPerView: 3.2,
            },
          }}
        >
          {categories.map((item) => (
            <SwiperSlide key={item.title}>
              <div className="group relative h-[500px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover duration-700 group-hover:scale-110"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent"></div>

                <div className="absolute bottom-8 left-8">
                  <h3 className="text-4xl font-light text-white">
                    {item.title}
                  </h3>

                  <button className="mt-4 border border-white px-6 py-2 text-sm uppercase tracking-[3px] text-white transition hover:bg-white hover:text-black">
                    View Gallery
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Categories;